import { render } from "./ProfileDetails.vue?vue&type=template&id=23856778"
import script from "./ProfileDetails.vue?vue&type=script&scoped=true&lang=js"
export * from "./ProfileDetails.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__